(function () {
  function clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function initStack(root) {
    if (!root || root.dataset.wxStackReady === '1') return;
    root.dataset.wxStackReady = '1';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-wx-stack-panel]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-wx-stack-card]'));
    if (panels.length < 2 || cards.length < 2) return;

    var ticking = false;

    function resetCard(card) {
      card.style.transform = 'translate3d(0,0,0) scale(1)';
      card.style.opacity = '1';
      card.style.filter = 'none';
      card.style.pointerEvents = 'auto';
    }

    function update() {
      ticking = false;

      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var nextPanel = panels[i + 1];

        if (!nextPanel) {
          resetCard(card);
          continue;
        }

        var stickyPx = parseFloat(getComputedStyle(card).top) || 0;
        var nextRect = nextPanel.getBoundingClientRect();
        var cardRect = card.getBoundingClientRect();

        // Start scrubbing once the next panel reaches the sticky band;
        // finish over a short distance so the handoff feels snappy.
        var start = stickyPx + cardRect.height * 0.08;
        var end = stickyPx + cardRect.height * 0.72;
        var progress = clamp((start - nextRect.top) / Math.max(end - start, 1), 0, 1);
        var eased = easeOutCubic(progress);

        var scale = 1 - eased * 0.07; // ~93%
        var lift = eased * -36;
        var depth = eased * -80;
        var fade = 1 - eased * 0.88;
        var blur = eased * 1.2;

        card.style.transform =
          'translate3d(0,' +
          lift +
          'px,' +
          depth +
          'px) scale(' +
          scale +
          ')';
        card.style.opacity = String(fade);
        card.style.filter = blur > 0.05 ? 'blur(' + blur + 'px)' : 'none';
        card.style.pointerEvents = progress > 0.55 ? 'none' : 'auto';
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-wx-shop-need]').forEach(initStack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-wx-shop-need]');
    if (root) {
      delete root.dataset.wxStackReady;
      initStack(root);
    }
  });
})();
